<template>
  <div class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-breadcrumb separator="/"  style="height:60px;margin-left: 10px; font-size:20px; display: flex ;align-items: center;">
      <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
      <el-breadcrumb-item >安全管理</el-breadcrumb-item>
      <el-breadcrumb-item >全部</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <el-form :inline="true" :model="searchFactor" style="margin-left: 10px;margin-top: 20px; text-align:left" class="search-form">
      <el-form-item label="教学楼:">
        <el-select style="width:150px"  v-model="searchFactor.buildingId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in buildingList"
            :key="index"
            :label="item.buildingName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="楼层:">
        <el-select style="width:80px" v-model="searchFactor.floor">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in 14"
            :key="index"
            :label="item - 4"
            :value="item - 4">
          </el-option>
        </el-select>
        </el-form-item> -->
      <el-form-item   label="实验室:">
        <el-input  style="width: 150px" v-model="searchFactor.storeroomName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="安全等级:">
        <el-select style="width:100px"  v-model="searchFactor.safeGradeId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in safeGradeList"
            :key="index"
            :label="item.safeGrade"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="团队:">  
        <!-- @change="searchDeptIdChange" -->
        <el-select style="width:100%"  v-model="searchFactor.deptId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item,index) in deptList"
            :key="index"
            :label="item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安全责任人:">
        <el-input  style="width: 150px" v-model="searchFactor.user" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col  style="padding: 0px; text-align: left; padding: 10px; " :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-for = "(viewStoreroomForm, index ) in tableData" :key = "index" >
        <el-card class="box-card">
          <div slot="header"  style="height: 20px;margin: 0;" class="clearfix">
            <el-tag>{{ viewStoreroomForm.buildingName }}</el-tag>
            <el-tag type="warning">{{ viewStoreroomForm.storeroomName }}</el-tag>
            <!-- <el-tag type="warning">{{ viewStoreroomForm.floor +'楼' }}</el-tag> -->
            <el-tag type="success">{{  viewStoreroomForm.deptName }}</el-tag>
          </div>
          <div style ="margin-top: 1px;" >
            <el-tag type="warning" style="width: 80px;text-align: left;">安全等级{{viewStoreroomForm.safeGrade}}</el-tag>
            <span style ="margin-left: 10px; ">{{ viewStoreroomForm.safeGradeRemark }}</span>
          </div>
          <div style ="margin-top: 5px;display: flex;">
            <div>
              <el-image  v-if = "viewStoreroomForm.headImage != null && viewStoreroomForm.headImage != ''"
              style="width: 80px; height: 80px ; border-radius: 1px;"
              :src="viewStoreroomForm.headImage"
              :fit="'fit'"></el-image>
              <el-avatar v-else  style="display: flex; background-color: rgb(107, 107, 221); height:80px;width: 80px; align-items: center; justify-content: space-around; "> {{ viewStoreroomForm.fullName  }} </el-avatar>
            </div>
            <div style="margin-left: 10px">
              <div>  
                  姓名: {{viewStoreroomForm.fullName }}({{viewStoreroomForm.userName }})
              </div>
              <div>  
                  电话: {{viewStoreroomForm.phoneNo }}
              </div>
              <div>  
                  邮箱: {{viewStoreroomForm.emial }}
              </div>
            </div>
          </div>
          <div style ="margin-top: 5px; height: 70px; overflow: auto;" >
          <el-tag type="warning" style ="width:80px">安全措施+{{ viewStoreroomForm.safeManageList == null ? 0 :viewStoreroomForm.safeManageList.length }}</el-tag>
          <span v-for="(item,index) in viewStoreroomForm.safeManageList" :key="index" style ="margin-left: 10px;">
            {{ (index + 1)+"."+ item.safeManageOption }}
          </span>
          </div>
          <!-- <div style ="margin-top: 10px;" >
            <el-tag type="warning">实验室说明</el-tag>
            <span>{{viewStoreroomForm.detail }}</span>
          </div> -->
        </el-card>
      </el-col>
    </el-row>
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin-top:10px">
    </el-pagination>
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import {MESSAGE_DURATION} from  '@/api/constant'
export default {
  name : 'pc_storeroom',
  data() {
    return {
      searchFactor:{
        storeroomName: '',
        detail: '',
        floor : '',
        buildingId :'',
        safeGradeId:'',
        deptId:'',
        safeUserId: '',
        user : '',
      },
      tableData: [],
      buildingList:[],
      deptList:[],
      safeGradeList:[],
      pager:{
        totalCount:0,
        pageSize :6                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
      },

    }
  },
  methods : {
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },
    onSearch(){
      this.storeroomListLoad(1)
    },
    handleCurrentChange(val){
      this.storeroomListLoad(val);
    },
    buildingListLoad(pageNo){
      let url = "/bc/exa/building/buildingPage"
      let dat0 = {
        pageSize: 100,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.buildingList = [];
            dat.data.forEach(t=>this.buildingList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到教学楼信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    storeroomListLoad(pageNo){
      let url = "/bc/exa/storeroom/storeroomPage"
      let {
          storeroomName,deptId,safeGradeId,safeUserId,floor,buildingId
      } = this.searchFactor
      let dat =  {
        storeroomName,deptId,safeGradeId,safeUserId,floor,buildingId,
        pageNo, pageSize:6
      }

      axios.post(url, dat).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.tableData = []
            response.data.data.data.forEach(t=>{
              this.tableData.push(t)
            })
            this.pager.totalCount = response.data.data.totalDataCount;
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) =>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    safeManageListLoad(pageNo){
      let url = "/bc/exa/safeManage/safeManagePage"
      let dat0 = {
        pageSize: 100,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.safeMangeList = [];
            dat.data.forEach(t=>this.safeMangeList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全措施信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },


    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat0 = { }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data;
          if(dat.data.length !== 0){
            this.deptList = [];
            response.data.data.forEach(t=>{
              if(t.level == 1){
                this.deptList.push({id: t.id,deptName: t.deptName })
              }
            })
          } else {
            this.$message({
              showClose: true,
              message: '未查询到团队信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    safeGradeListLoad(){
      let url = "/bc/exa/safeGrade/all"
      let dat0 = {  
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data
          if(dat.data.length !== 0){
            this.safeGradeList = [];
            dat.data.forEach(t=>this.safeGradeList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全等级信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    
  },
  created(){
    setTimeout(()=>{this.deptListLoad()},200)
    setTimeout(()=>this.buildingListLoad(1),200)
    setTimeout(()=> this.safeGradeListLoad(),200)
    setTimeout(()=>this.safeManageListLoad(1),200)
    this.storeroomListLoad(1)
  },
  components: {
  }
}
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  // background-color:rgb(130, 20, 20);
  // background-color:#f9fafc;
  color: #333;
  margin: auto;
  text-align: center;
  height: calc(100% - 20px);
  overflow:auto;
}

.el-row {
  padding: auto;
  margin: auto;

  width: 100%;
  font-size: large;
  text-align: center;
  .el-col{

    height: 300px;
  }
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  width: 100%;
  margin: auto;
  width: 100%
}

</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_storeroom.vue